import { useMemo } from "react";
import { TenantId } from "@visioni/a3s-schema";
import { getTenantDisplayName, useTenant } from "@src/features/tenants";

/**
 * A tenant's display name, or `undefined` when this app's directory does not
 * hold it — ordinary, not an error: an int stack replicating prod's Patriot
 * names prod tenants int has never heard of.
 */
export function useDirectoryTenantName(): (tenantId: string) => string | undefined {
  const { tenants } = useTenant();
  const names = useMemo(
    () => new Map(tenants.map((t) => [TenantId.toString(t.id), getTenantDisplayName(t)])),
    [tenants],
  );
  return (tenantId) => names.get(tenantId);
}
